import { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';

import { CloseOutlined } from '@mui/icons-material';

import TemplatesPanel from '../../../../../Common/components/Template/TemplatesPanel';
import TemplateTextPanel from '../../../../../Common/components/Template/TemplateTextPanel';
import { dialogHeaderStyles } from '../../../../../Common/components/Styles/InputStyles';
import CommonDialogActions from '../../../../../Common/components/CommonDialogActions';
import {dialogContentSx,dialogPaperSx,panelsWrapperSx} from './Styles'



const closeIconSx = {
  fontSize: 22
};

const initialTopics = [
  {
    id: 1,
    title: 'Annual Physical Exam'
  },
  {
    id: 2,
    title: 'Back Pain Exam'
  },
  {
    id: 3,
    title: 'Chest Pain Exam'
  },
  {
    id: 4,
    title: 'Knee Pain Exam'
  },
  {
    id: 5,
    title: 'Leg Edema Exam'
  },
  {
    id: 6,
    title: 'Neurologic Exam'
  },
  {
    id: 7,
    title: 'Routine Physical Exam'
  },
  {
    id: 8,
    title: 'URI Exam'
  },
  {
    id: 9,
    title: 'UTI Exam'
  }
];

const initialTemplateText = {
  1: [
    {
      id: 1,
      text: 'Neck: supple, no lymphadenopathy or thyromegaly',
      checked: true
    },
    {
      id: 2,
      text: 'No carotid bruits appreciated',
      checked: true
    },
    {
      id: 3,
      text: 'Heart RRR w/o murmurs or gallops',
      checked: true
    },
    {
      id: 4,
      text: 'Lungs: clear bilaterally without rhonchi or crackle',
      checked: false
    },
    {
      id: 5,
      text: 'No reproducible chest wall tenderness',
      checked: false
    },
    {
      id: 6,
      text: 'Ext: no cyanosis or pitting edema',
      checked: false
    }
  ]
};

const ObjectiveTemplatesDialog = ({ open, onClose, onSave }) => {
  const [topics, setTopics] = useState(initialTopics);
  const [selectedTopicId, setSelectedTopicId] = useState(1);
  const [templateText, setTemplateText] = useState(initialTemplateText);

  const selectedTopic =
    topics.find(topic => topic.id === selectedTopicId) || topics[0];

  const selectedTemplateText = templateText[selectedTopicId] || [];

  const handleAddTopic = value => {
    const nextId =
      topics.length > 0
        ? Math.max(...topics.map(topic => topic.id)) + 1
        : 1;

    const newTopic = {
      id: nextId,
      title: value
    };

    setTopics(previous => [...previous, newTopic]);
    setSelectedTopicId(nextId);

    setTemplateText(previous => ({
      ...previous,
      [nextId]: []
    }));
  };

  const handleEditTopic = topic => {
    console.log('Edit topic:', topic);
  };

  const handleAddText = value => {
    const currentRows = templateText[selectedTopicId] || [];

    const nextId =
      currentRows.length > 0
        ? Math.max(...currentRows.map(item => item.id)) + 1
        : 1;

    setTemplateText(previous => ({
      ...previous,
      [selectedTopicId]: [
        ...currentRows,
        {
          id: nextId,
          text: value,
          checked: true
        }
      ]
    }));
  };

  const handleToggleText = id => {
  setTemplateText(previous => ({
    ...previous,
    [selectedTopicId]: (previous[selectedTopicId] || []).map(item =>
      item.id === id
        ? {
            ...item,
            checked: !item.checked
          }
        : item
    )
  }));
};

  const handleEditText = (itemId, updatedText) => {
    setTemplateText(previous => ({
      ...previous,
      [selectedTopicId]: (previous[selectedTopicId] || []).map(item =>
        item.id === itemId
          ? {
              ...item,
              text: updatedText
            }
          : item
      )
    }));
  };

  const handleReorderText = reorderedRows => {
    setTemplateText(previous => ({
      ...previous,
      [selectedTopicId]: reorderedRows
    }));
  };

 const handleSave = () => {
  const selectedRows = templateText[selectedTopicId] || [];

  const selectedText = selectedRows
    .filter(item => item.checked)
    .map(item => item.text)
    .join('\n');

  onSave({
    text: selectedText,
    topics,
    selectedTopicId,
    templateText
  });

  onClose();
};

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={false}
      slotProps={{
        paper: {
          sx: dialogPaperSx
        }
      }}
    >
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>
            Objective Templates
          </Typography>

          <Typography sx={dialogHeaderStyles.subtitle}>
            Create and manage templates for documenting clinical findings.
          </Typography>
        </Box>

        <IconButton
          aria-label="Close subjective templates dialog"
          onClick={handleClose}
          size="small"
          sx={dialogHeaderStyles.dialogheaderclose}
        >
          <CloseOutlined sx={closeIconSx} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={dialogContentSx}>
        <Box sx={panelsWrapperSx}>
          <TemplatesPanel
            topics={topics}
            selectedTopicId={selectedTopicId}
            onSelectTopic={setSelectedTopicId}
            onAddTopic={handleAddTopic}
            onEditTopic={handleEditTopic}
          />

          <TemplateTextPanel
            title={selectedTopic?.title || 'Template'}
            rows={selectedTemplateText}
            onAddText={handleAddText}
            onToggleText={handleToggleText}
            onEditText={handleEditText}
            onReorderText={handleReorderText}
            showCheckbox={true}
          />
        </Box>
      </DialogContent>

      <CommonDialogActions
        onCancel={handleClose}
        onSubmit={handleSave}
        submitText="Save"
        disabled={false}
      />
    </Dialog>
  );
};

ObjectiveTemplatesDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func
};

ObjectiveTemplatesDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSave: () => {}
};

export default ObjectiveTemplatesDialog;